<template>
  <v-container>
    <v-card>
      <v-card-title class="error white--text">
        Profit or loss statement
        <v-spacer></v-spacer>
        <v-btn
          v-if="salesIncom.length"
          icon
          class="d-print-none"
          @click="PrintPage"
          small
          color="white"
        >
          <v-icon>fas fa-print</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-card flat>
          <v-data-table
            :loading="isloading"
            hide-default-footer
            :headers="headers"
            :items="salesIncom"
          >
            <template v-slot:top>
              <v-toolbar flat color="grey lighten-4">
                <v-toolbar-title v-if="fromDate != '' && toDate != ''"
                  >{{ fromDate }} --- {{ toDate }}</v-toolbar-title
                >

                <v-divider class="mx-4" inset vertical></v-divider>

                <searchDate
                  Thismonth
                  :searching="searching"
                  :SearchFun="OnSearch"
                ></searchDate>
                <v-spacer></v-spacer>
                <!-- {{ GrossProfit.toLocaleString() }} -->
              </v-toolbar>
            </template>
            <template v-slot:item.in="{ item }">
              {{ item | formatAmount }}
            </template>
            <template v-slot:item.Tran="{}">
              <v-btn icon color="success">
                <v-icon>fas fa-info-circle</v-icon>
              </v-btn>
            </template>
            <template v-if="!isloading" #body.append>
              <tr v-if="salesIncom.length" class="grey lighten-1 FootTable">
                <td :colspan="headers.length - 1">Gross Profit</td>
                <td class="leftAlign">{{ GrossProfit.toLocaleString() }}</td>
              </tr>

              <tr>
                <td>Total Eexpense</td>
                <td>({{ TotalExpense.Amount.toLocaleString() }})</td>
              </tr>

              <tr
                :class="
                  NetProfit < 0 ? 'error white--text' : 'teal white--text'
                "
              >
                <td :colspan="headers.length - 1">Net Profit</td>
                <td class="leftAlign">{{ NetProfit.toLocaleString() }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { EventBus } from "@/main";
export default {
  components: {
    searchDate: () => import("@/components/util/searchDate.vue"),
    // PrintView: () => import("@/components/Branches/Sales/printSaleReport.vue")
  },
  data() {
    return {
      SalesRepo: "/Reports/sales/income",
      searching: false,
      isloading: false,
      fromDate: "",
      toDate: "",
      salesIncom: [],
      TotalExpense: { Amount: 0 },
      headers: [
        {
          text: "Description",
          align: "left",
          value: "AccountName",
        },
        { text: "", value: "in" },
        // { text: "Tran", value: "Tran" }
        // { text: "User", value: "User" },
        // { text: "View", class: "d-print-none", value: "print" }
      ],
    };
  },
  filters: {
    formatAmount(item) {
      if (item.AccountName !== "Sales")
        return `(${item.Amount.toLocaleString()})`;
      return `${item.Amount.toLocaleString()}`;
    },
  },
  computed: {
    GrossProfit() {
      return this.salesIncom.reduce((t, s) => {
        if (s.AccountName === "Sales") return (t += s.Amount);
        return (t -= s.Amount);
      }, 0);
    },
    NetProfit() {
      return this.GrossProfit - this.TotalExpense.Amount;
    },
  },
  methods: {
    async PrintPage() {
      //   this.itemPerPage = this.Transactions.length;
      await EventBus.Printing(false);
      window.print();
      EventBus.Printing(true);
      //   this.itemPerPage = 10;
    },
    OnSearch(from, to) {
      this.fromDate = from;
      this.toDate = to;

      this.salesIncom = [];

      this.searching = true;
      this.isloading = true;

      this.GetReq()
        .then(result => {
          // console.log(result[0]);
          this.isloading = false;
          this.searching = false;
          this.salesIncom = result.data.Sale;
          this.TotalExpense = result.data.Expense;
        })
        .catch(() => {
          this.isloading = false;
          this.searching = false;
          // console.log(error);
        });
    },

    GetReq() {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: this.SalesRepo,
        query: { from: this.fromDate, to: this.toDate },
      });
    },
    loadSales() {
      try {
        this.searching = true;
        this.isloading = true;
        this.GetReq({ url: this.SalesRepo, query: {} })
          .then(value => {
            this.searching = false;
            this.isloading = false;
            this.salesIncom = value.data.Sale;
            this.TotalExpense = value.data.Expense;
          })
          .catch(err => {
            this.searching = false;
            this.isloading = false;
            console.log(err);
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    //   console.log()
    const { date, Thismonth } = this.Current();
    this.fromDate = Thismonth;
    this.toDate = date;
    this.loadSales();
  },
};
</script>
<style scoped>
.FootTable td {
  font-weight: bold;
  border-top: 5px solid #f44336;

  /* font-size: 50px; */
}
.leftAlign {
  text-align: right;
}
</style>
